<template>
    <div class="section-tabs">
        <ul class="section-tabs__list no-bullet clearfix">
            <li
                v-for="(tab, idx) in tabPanes"
                @click="changeTab(idx)"
                class="section-tabs__list-item"
                :class="{'active': idx === activeTab}">
                {{ tab.label }} <span v-if="tab.labelValue">{{ tab.labelValue }}</span>
            </li>
        </ul>
        <div class="section-tabs__content">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    /**
     * Tabs Component
     */
    export default {
        name: 'tabs',
        data () {
            return {
                tabPanes: [],
                activeTab: 0
            }
        },
        methods: {
            changeTab (activeTab) {
                this.activeTab = activeTab
            }
        },
        watch: {
            tabPanes: function () {
                this.tabPanes[this.activeTab].active = true
            },
            activeTab: function (activeTab) {
                this.tabPanes.forEach((pane, idx) => {
                    pane.active = (idx === activeTab)
                })
            }
        },
        mounted () {
            this.$bus.$on('change-tab', tab => {
                this.activeTab = tab
            })
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/general/Tabs.vue